(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
(() => {
  const slot = document.querySelector('[data-fp-flower-chat]');
  if (!slot || slot.dataset.fpChatBound) return;
  const button = slot.querySelector('button');
  if (!button) return;
  slot.dataset.fpChatBound = 'true';
  const mobile = window.matchMedia('(max-width: 749px)');
  let host;
  const observedShadows = new Set();
  let openedFromInline = false;
  let wasOpen = false;
  let opening = false;
  let openingTimeout;
  let failed = false;
  const activator = () => {
    const root = host?.shadowRoot;
    const direct = root?.querySelector('button[part~="activator"]');
    if (direct) return direct;
    const runtime = root?.querySelector('shopify-agent-runtime[exportparts]');
    return runtime?.getAttribute('exportparts').split(',').some((part) => part.trim() === 'activator')
      ? runtime.shadowRoot?.querySelector('button[part~="activator"]')
      : null;
  };
  const restore = () => {
    document.body.classList.remove('fp-flower-chat-ready');
    slot.hidden = true;
    button.disabled = false;
    button.setAttribute('aria-expanded', 'false');
  };
  const sync = () => {
    const nativeButton = activator();
    const label = nativeButton?.getAttribute('aria-label')?.trim();
    const open = host?.hasAttribute('open');
    const available = !failed && slot.isConnected && host?.isConnected && ((nativeButton && !nativeButton.disabled && label) || (open && button.textContent));
    if (!available || !mobile.matches) {
      restore();
      return;
    }
    if (label && button.textContent !== label) button.textContent = label;
    slot.hidden = false;
    document.body.classList.add('fp-flower-chat-ready');
    button.setAttribute('aria-expanded', String(open));
    button.disabled = opening || open;
    if (open) {
      opening = false;
      clearTimeout(openingTimeout);
    }
    if (wasOpen && !open && openedFromInline) {
      openedFromInline = false;
      button.disabled = false;
      button.focus({ preventScroll: true });
    }
    wasOpen = open;
  };
  const shadowObserver = new MutationObserver(() => bind());
  const hostObserver = new MutationObserver(sync);
  const bind = () => {
    const hosts = document.querySelectorAll('shopify-chat');
    const next = hosts.length === 1 ? hosts[0] : null;
    if (next !== host) {
      restore();
      hostObserver.disconnect();
      shadowObserver.disconnect();
      host = next;
      observedShadows.clear();
      wasOpen = false;
      openedFromInline = false;
      opening = false;
      clearTimeout(openingTimeout);
      if (host) hostObserver.observe(host, { attributes: true, attributeFilter: ['open', 'view', 'class'] });
    }
    const roots = [host?.shadowRoot, host?.shadowRoot?.querySelector('shopify-agent-runtime')?.shadowRoot];
    for (const root of roots) {
      if (root && !observedShadows.has(root)) {
        observedShadows.add(root);
        shadowObserver.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label', 'disabled'] });
      }
    }
    sync();
  };
  button.addEventListener('click', (event) => {
    event.stopPropagation();
    if (!mobile.matches || opening || host?.hasAttribute('open')) return;
    const nativeButton = activator();
    if (!host?.isConnected || !nativeButton || nativeButton.disabled) {
      restore();
      return;
    }
    openedFromInline = true;
    opening = true;
    button.disabled = true;
    const openingHost = host;
    try {
      openingTimeout = setTimeout(() => {
        if (opening && host === openingHost && !host?.hasAttribute('open')) {
          failed = true;
          openedFromInline = false;
          opening = false;
          restore();
        }
      }, 6000);
      setTimeout(() => {
        try {
          if (host !== openingHost || !mobile.matches || !nativeButton.isConnected) {
            opening = false;
            clearTimeout(openingTimeout);
            restore();
            return;
          }
          nativeButton.click();
          sync();
        } catch {
          failed = true;
          opening = false;
          openedFromInline = false;
          clearTimeout(openingTimeout);
          restore();
        }
      }, 0);
    } catch {
      clearTimeout(openingTimeout);
      failed = true;
      openedFromInline = false;
      opening = false;
      restore();
    }
  });
  const pageObserver = new MutationObserver(bind);
  pageObserver.observe(document.body, { childList: true, subtree: true });
  mobile.addEventListener('change', () => {
    if (!mobile.matches) openedFromInline = false;
    bind();
  });
  customElements.whenDefined('shopify-chat').then(bind);
  customElements.whenDefined('shopify-agent-runtime').then(bind);
  bind();
})();

  } catch(e) { console.error(e); }
})();
})();
